/**
 * Tipo "Vendedor" no cadastro de contatos: marcar ou desmarcar cria ou exclui o vendedor, o que exige sellers:create e
 * sellers:delete. Sem as duas, a opção fica desabilitada e a seleção mantém o tipo como estava (um clique sem Ctrl
 * num select múltiplo desmarcaria até a opção desabilitada).
 */
export const canManageSellerType = (can: (action: "create" | "delete") => boolean) =>
  can("create") && can("delete");

export function keepSellerType(
  next: readonly string[],
  prev: readonly string[],
  sellerTypeId: string | undefined,
  canManage: boolean,
): string[] {
  if (canManage || !sellerTypeId) return [...next];
  const rest = next.filter((t) => t !== sellerTypeId);
  return prev.includes(sellerTypeId) ? [...rest, sellerTypeId] : rest;
}
